import Button from 'src/ui/atoms/Button'

import useEsdtToken from './useEsdtToken'
import { IProject } from '../../useProjectApi'

const PauseToken = ({ project }: { project: IProject }) => {
  const { isLoading, handleToken, isWalletConnected } = useEsdtToken({
    payloadKey: 'esdtPausePayload',
  })

  const handlePause = async () => {
    await handleToken({
      type: 'pause',
      network: project.data.network,
      tokenTicker: project.data.detailedTokenTicker,
    })
  }

  const handleUnPause = async () => {
    await handleToken({
      type: 'unpause',
      network: project.data.network,
      tokenTicker: project.data.detailedTokenTicker,
    })
  }

  return (
    <div className="flex justify-end gap-2">
      <Button
        size="M"
        name="Pause"
        disabled={!isWalletConnected}
        loading={isLoading}
        onClick={handlePause}
      />

      <Button
        size="M"
        name="UnPause"
        disabled={!isWalletConnected}
        loading={isLoading}
        onClick={handleUnPause}
      />
    </div>
  )
}

export default PauseToken
